import React from 'react';
import {
  Route, Switch, Redirect, BrowserRouter,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import LogIn from '../Auth/LogIn/index';
import Dashboard from '../Dashboard/index';
import Profile from '../Account/Profile/index';

const Pages = () => (
  <Switch>
    <Route path="/dashboard" component={Dashboard} />
    <Route path="/profile" component={Profile} />
  </Switch>
);

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/" component={Pages} />
    </div>
  </div>
);

wrappedRoutes.propTypes = {
  params: PropTypes.shape({}).isRequired,
};

const PrivateRoute = ({
  component: Component,
  params,
  authed,
  // email,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => (authed === true
      ? <Component params={params} {...props} />
      : <Redirect to={{ pathname: '/auth/login', state: { from: props.location } }} />
    )}
  />
);

PrivateRoute.propTypes = {
  authed: PropTypes.bool.isRequired,
  location: PropTypes.shape({}),
  component: PropTypes.elementType.isRequired,
  params: PropTypes.shape({}).isRequired,
  // email: PropTypes.string,
};

PrivateRoute.defaultProps = {
  location: {},
  // email: '',
};

const PublicRoute = ({ component: Component, authed, ...rest }) => (
  <Route
    {...rest}
    render={props => (authed === false
      ? <Component {...props} />
      : <Redirect to="/dashboard" />
    )}
  />
);

PublicRoute.propTypes = {
  authed: PropTypes.bool.isRequired,
  component: PropTypes.elementType.isRequired,
};

const Router = ({
  authed, params,
}) => (
  <MainWrapper>
    <main>
      <BrowserRouter>
        <Switch>
          <PublicRoute exact authed={authed} path="/auth/login" component={LogIn} />
          <PrivateRoute params={params} exact authed={authed} path="/dashboard" component={wrappedRoutes} />
          <PrivateRoute params={params} authed={authed} path="/" component={wrappedRoutes} />
        </Switch>
      </BrowserRouter>
    </main>
  </MainWrapper>
);

Router.propTypes = {
  authed: PropTypes.bool.isRequired,
  params: PropTypes.shape({}),
  // email: PropTypes.string,
};

Router.defaultProps = {
  params: {},
  // email: '',
};

export default Router;
